<template>
  <div>
    <PlatformSl
      ref="platform"
      :bridge="bridge"
      :localStoragePrefix="localStoragePrefix"
      :buttons="buttons"
      :outputs="outputs"
      :uarts="uarts"
      :leds="leds"
      :languages="languages"
      :vbusSpecifications="vbusSpecifications"
      displayType="NT7538"
      @initialized="platformInitialized"
    ></PlatformSl>
  </div>
</template>

<script>
import { BasicPlatformWasiBridge } from '@/bridges/BasicPlatformWasiBridge';

import PlatformSl from '@/device-platforms/PlatformSl.vue';

const SpecificationFile = require('resol-vbus/src/specification-file');
const Specification = require('resol-vbus/src/specification');



export default {
  props: [
    'localStoragePrefix',
  ],

  components: {
    PlatformSl,
  },


  data: () => ({
    label: 'RESOL DeltaSol SLT 2.03',
    wasmUrl:'/100000014_DeltaSolSLT_2.03_SNAPSHOT-SN-DZ.wasm',

    wasmModule: null,
    bridge: null,
    vbusSpecifications: [],
    prodswitch: [
      { idx: 0},
    ],

    buttons: [
      { platformIndex: 0,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S1', },
      { platformIndex: 1,conversion: 'resistorPt1000Temperature', value: null, initialValue: 52.3, name: 'S2', },
      { platformIndex: 2,conversion: 'resistorPt1000Temperature', value: null, initialValue: 62.3, name: 'S3', },
      { platformIndex: 3,conversion: 'resistorPt1000Temperature', value: null, initialValue: 72.3, name: 'S4', },
      { platformIndex: 4,conversion: 'resistorPt1000Temperature', value: null, initialValue: 12.3, name: 'S5', },
      { platformIndex: 5,conversion: 'voltageGaTemperature', value: null, initialValue: 12.3, name: 'S6', },
      { platformIndex: 6,conversion: 'voltageVfsFlow', conversions: [ 'voltageVfsFlow', 'voltageRpsPressure' ],value: null, initialValue: 0, name: "S6", },
      { platformIndex: 8,conversion: 'frequencyPAW_FlowRotor_DN20', conversions: ['frequencyPAW_FlowRotor_DN20', 'frequencyPAW_FlowRotor_DN25'], value: null, initialValue: 0, name: 'S7', },
    ],
    outputs: [
      { name: 'R1', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R2', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R3', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'R4', conversion: 'dutycyclePercent', value: null }, // Relais
      { name: 'A1', conversion: 'dutycyclePercent', value: null }, // PWM / 0-10V
      { name: 'A2', conversion: 'dutycyclePercent', value: null }, // PWM / 0-10V
    ],

    leds: [
        { state: null }
    ],

    uarts: [
      { name: 'UART0', kind: 'VBus', label: 'GP' },
      { name: 'UART1', kind: 'VBus', label: 'DDS' },
    ],

    languages: [
      { value: 0, text: 'Deutsch', short: 'de' },
      { value: 1, text: 'English', short: 'en' },
    ],
  }),

  created() {
  },

  mounted() {
  },

  methods: {
    async prepareDevice() {
      const response = await fetch(this.wasmUrl);
      const wasmArrayBuffer = await response.arrayBuffer();
      // console.log(wasmArrayBuffer);

      this.wasmModule = await WebAssembly.compile(wasmArrayBuffer);
      // console.log(this.wasmModule);

      this.bridge = new BasicPlatformWasiBridge(this.wasmModule);
      await this.bridge.instantiate();

      this.$refs.platform.prepareBridgeable();

      const vsfResponse = await fetch('/vbus_specification.vsf');
      const vsfArrayBuffer = await vsfResponse.arrayBuffer();
      const vsfBuffer = Buffer.from(vsfArrayBuffer);
      const specificationFile = new SpecificationFile(vsfBuffer);
      const specification = new Specification({ specificationFile });
      this.vbusSpecifications.push(specification);
    },

    startDevice() {
      this.bridge.start();
    },

    restartDevice() {},

    platformInitialized() {
    },
  },
};
</script>

<style>

</style>
